import { ComposeError } from '@/services/composeService';

/** Tooltip on every flagged value (Faktenwächter). */
export const FLAG_HINT = 'Stand nicht in deinem Entwurf – bitte prüfen';

export const IMPROVE_ERROR_TEXT: Record<string, string> = {
  rate_limited: 'Gerade zu viele Anfragen – bitte einen Moment warten.',
  invalid_text: 'Dieser Text lässt sich nicht verbessern.',
  not_found: 'Dieser Chat ist nicht mehr verfügbar.',
  network: 'Keine Verbindung zum Server – bitte noch einmal versuchen.',
  auth: 'Sitzung abgelaufen – bitte neu anmelden.',
  upstream: 'Verbessern hat gerade nicht geklappt – bitte noch einmal versuchen.',
};

export const DICTATION_TEXT = {
  unsupported: 'Sprachaufnahme wird von diesem Browser nicht unterstützt.',
  denied: 'Kein Zugriff aufs Mikrofon – bitte in den Browser-Einstellungen erlauben.',
  noMicrophone: 'Kein Mikrofon gefunden.',
  busy: 'Das Mikrofon wird gerade von einer anderen Anwendung verwendet.',
  startFailed: 'Die Aufnahme ließ sich nicht starten – bitte noch einmal versuchen.',
  tooShort: 'Aufnahme zu kurz – bitte etwas länger sprechen.',
  nothingUnderstood: 'Nichts verstanden – bitte noch einmal sprechen.',
};

export const TRANSCRIBE_ERROR_TEXT: Record<string, string> = {
  rate_limited: IMPROVE_ERROR_TEXT.rate_limited,
  not_found: IMPROVE_ERROR_TEXT.not_found,
  network: IMPROVE_ERROR_TEXT.network,
  auth: IMPROVE_ERROR_TEXT.auth,
  too_large: 'Die Aufnahme ist zu groß – bitte kürzer diktieren.',
  too_short: DICTATION_TEXT.tooShort,
  unsupported_format: 'Dieses Aufnahmeformat wird nicht unterstützt.',
  invalid_text: 'Die Aufnahme ließ sich nicht lesen – bitte noch einmal versuchen.',
  upstream: 'Umwandeln hat gerade nicht geklappt – bitte noch einmal versuchen.',
};

export function errorText(error: unknown, table: Record<string, string>): string {
  const code = error instanceof ComposeError ? error.code : 'upstream';
  return table[code] ?? table.upstream;
}
